import React from 'react';
import PropTypes from 'prop-types';
import Repeat from 'react-repeat-component';

import styles from './Placeholder.module.scss';

const Placeholder = props => {
  const { children, component, repeat, ready } = props;
  return !ready ? (
    <Repeat times={repeat} className={styles.PlaceholderWrapper}>
      {i => <div key={i}>{component}</div>}
    </Repeat>
  ) : (
    children
  );
};

Placeholder.propTypes = {
  children: PropTypes.node,
  component: PropTypes.object.isRequired,
  repeat: PropTypes.number,
  ready: PropTypes.bool.isRequired
};

Placeholder.defaultProps = {
  repeat: 1,
  children: []
};

export default Placeholder;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/Placeholder.js